import { Injectable } from '@angular/core';
import { AdjustmentStore } from './adjustment.store';
import { ReservationStatusCode } from '../models/reservation-status-code.enum';
import { map, mergeMap } from 'rxjs/operators';
import { TaxDeterminationStore } from './tax-determination.store';
import { Payment } from '../models/payment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CalculatePaymentService {

  constructor(private adjustmentStore: AdjustmentStore,
    private taxDeterminationStore: TaxDeterminationStore
  ) { }

  getCalculatedPayment(eventPartyId: number, subscriberVendor: boolean): Observable<number> {
    return this.adjustmentStore.getVendorCalculatedPayment(eventPartyId, ReservationStatusCode.CHECKED_OUT, subscriberVendor, 0).pipe(
      map(
        (vendorCalculatedPayment: number) => vendorCalculatedPayment ? vendorCalculatedPayment : 0
      )
    );
  }

  getVendorCalculatedTaxes(eventPartyId: number, subscriberVendor: boolean, applyOoiv: boolean): Observable<number> {
    return this.getCalculatedPayment(eventPartyId, subscriberVendor).pipe(
      mergeMap(
        (calculatedPayment: number) => this.taxDeterminationStore.getVendorCalculatedTaxes(eventPartyId, calculatedPayment, applyOoiv)
      )
    );
  }

  getCalculatedPaymentWithTax(eventPartyId: number, subscriberVendor: boolean, applyOoiv: boolean, prepayment: Payment)
  : Observable<number> {
    return this.getVendorCalculatedTaxes(eventPartyId, subscriberVendor, applyOoiv).pipe(
      mergeMap(
        (vendorCalculatedTaxes: number) =>
          this.adjustmentStore.getVendorCalculatedPayment(
            eventPartyId, ReservationStatusCode.CHECKED_OUT, subscriberVendor, vendorCalculatedTaxes)
      ),
      map(
        (vendorCalculatedPayment: number) => {
          const payment = vendorCalculatedPayment ? vendorCalculatedPayment : 0;
          const prepaymentAmount = prepayment && prepayment.commissionAmount ? prepayment.commissionAmount : 0;
          return payment - prepaymentAmount;
        }
      )
    );
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/calculate-payment.service.ts